// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"430":"ab0ea32e","791":"a30fbd19"}[chunkId] + ".chunk.js";
};